/**
 * Central TanStack Query keys for wallet-scoped server data.
 * Use these everywhere so portfolio + pending-fees stay deduplicated across
 * lobby nav, header, wallet dropdown, and portfolio page.
 */
export const queryKeys = {
  wallet: ['wallet'] as const,

  portfolio: (address: string | null | undefined) =>
    ['wallet', 'portfolio', (address ?? '').toLowerCase()] as const,

  /** Parsed pending-fees payload (same shape as header `claimableFeesData`). */
  pendingFees: (address: string | null | undefined) =>
    ['wallet', 'pending-fees', (address ?? '').toLowerCase()] as const,

  /** Batched GET /api/me/summary — optional hydration of the two keys above. */
  meSummary: (address: string | null | undefined) =>
    ['wallet', 'me-summary', (address ?? '').toLowerCase()] as const,

  /** Live coin page payload from `/api/coin/[address]` (shared with demo fetcher). */
  coinPage: (coinAddress: string) => ['coin', coinAddress] as const,

  userPlinth: (address: string | null | undefined) =>
    ['users', 'plinth', (address ?? '').toLowerCase()] as const,
};
